const EXTENSION_LANGUAGE_MAP: Record<string, string> = {
  json: 'json',
  html: 'html',
  htm: 'html',
  css: 'css',
  scss: 'css',
  less: 'css',
  js: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  jsx: 'javascript',
  ts: 'typescript',
  tsx: 'typescript',
  svg: 'xml',
  xml: 'xml',
  md: 'markdown',
  markdown: 'markdown',
  atlas: 'plaintext',
  txt: 'plaintext',
  log: 'plaintext',
  env: 'plaintext',
};

export function getFileExtension(filePath?: string): string {
  if (!filePath) return '';
  return filePath.split('.').pop()?.toLowerCase() || '';
}

export function detectMonacoLanguage(fileName?: string): string {
  const ext = getFileExtension(fileName);
  return EXTENSION_LANGUAGE_MAP[ext] || 'plaintext';
}

export function isTextFileExtension(filePath?: string): boolean {
  const ext = getFileExtension(filePath);
  return ext in EXTENSION_LANGUAGE_MAP;
}

export function isHtmlFile(filePath?: string): boolean {
  return ['html', 'htm'].includes(getFileExtension(filePath));
}

export function isSvgFile(filePath?: string): boolean {
  return getFileExtension(filePath) === 'svg';
}

export function isImageFile(filePath?: string): boolean {
  return ['png', 'jpg', 'jpeg', 'gif', 'webp', 'ico'].includes(getFileExtension(filePath));
}

export function isAudioFile(filePath?: string): boolean {
  return ['mp3', 'wav', 'ogg', 'm4a', 'aac'].includes(getFileExtension(filePath));
}
